import { useFetch } from 'vfetcher';
import store from '@/store';
import router from "@/router";
import { useErrorHandler, ErroneousResponseError } from "./error";

const handleResponseError = (internal, friendly) => {
  useErrorHandler(new ErroneousResponseError(internal, friendly), {
    notify: true,
    fallback: 'Sorry, access to this resource forbidden.',
  });
}

export function useAPI(url, options = {}) {
  const platformHeader = {
    "X-Sez-Platform": "web",
  };

  return useFetch(url, {
    ...options,
    baseURL: '/api',
    headers: {
      ...options.headers,
      ...platformHeader,
    },
    async onResponseError({ request, options, response }) {
      if (typeof response._data === 'object') {
        const internal = response._data.message;
        if (response.status === 403) {
          const friendly = 'This account no longer exists. Contact support for help, or log out to return to the home screen.';
          handleResponseError(internal, friendly);
        }
        if (response.status === 401) {
          const friendly = 'Session expired. Please log in to continue.';
          store.dispatch('logOut');
          //router.go(); Test later which are better to use
          router.push('/');
          handleResponseError(internal, friendly);
        }
      }
    }
  })
}
